<app-page [simpleTopBar]="globalVars.isMobile()" title="{{ 'diamonds_pages.diamonds_given_by' | transloco }}">
  <diamonds-details></diamonds-details>
</app-page>
